import { Header } from '@components/layout/Header/Header';
import { ReactNode } from 'react';
import { NavbarTheme } from 'src/types/header-types';
import { useRevalidateOnRefocus } from '@hooks/useSwrApi';


// Interface
// ******************************************
interface LayoutWithHeaderProps {
  children?: ReactNode,
  navbarTheme?: NavbarTheme,
}


/**
 * @description Layout with header and no footer.
 * - children - The children to render inside the layout.
 * - navbarTheme - The theme of the navbar, 'default' | 'transparent'.
 *
 * @example
 * // if you want a transparent header, pass the navbarTheme prop
 * MyPage.getLayout = function getLayout(page: ReactNode) {
 *   return (
 *     <LayoutWithHeader navbarTheme="transparent">
 *       {page}
 *     </LayoutWithHeader>
 *   );
 * };
 */
export const LayoutWithHeader = function LayoutFunction(props: LayoutWithHeaderProps) {
  // Destructure props
  const {
    children,
    navbarTheme,
  } = props;

  // Check if we should revalidate SWR cache on tab refocus
  useRevalidateOnRefocus();

  return (
    <>
      {/* Place all the sticky top banners in Header component */}
      <Header navbarTheme={navbarTheme} />
      {children}
    </>
  );
};
